import React, { useEffect, useState } from "react";
import { getMenuDatas } from "./menu.config";
import "./menu.style.css";
import CustomIcons from "../../../../components/icons/kIcons.component";
import jwtDecode from "jwt-decode";
import ReactHtmlParser from "react-html-parser"
export default function MenuComp(props) {
  let lang = props.state.language;
  const homeData = {
    path: "/",
    isDirect: true,
  };
  const handlePreventClose = (e) => {
    e.stopPropagation();
  };
  let userType = props.state.payload ? jwtDecode(props.state.payload) : {};
  let activeUserType =
    userType?.user?.user_type ||
    userType?.data?.user_type ||
    userType?.user_type ||
    (userType?.actor === "company_user" ? 4 : null);
  let activeUserStatus =
    userType?.user?.status ??
    userType?.status ??
    (userType?.actor === "company_user" ? 2 : null);

  const MenuDatas = getMenuDatas(props.auth);
  return (
    <div className="new-menu-bg anima" onClick={(e) => props.handleClose(e)}>
      <div
        className="new-menu-container"
        onClick={(e) => handlePreventClose(e)}
      >
        <div className="menu-main-section">

          {MenuDatas?.map((item) => {
            return (
              <React.Fragment key={item.id + "main"}>
                {item.hideOnAuth ? (
                  <>
                    {!props.auth && (
                      <>
                        <div className="new-menu-item" key={item.id}>
                          <div className="new-menu-title">
                            {lang === "ma" ? item.label_ma : item.label_en}
                          </div>
                          <div className="new-menu-subItem">
                            {item.children.map((ch) => (
                              <React.Fragment key={ch.id}>
                                {ch.show && (
                                  <div
                                    className="new-menu-item-data"
                                    onClick={(e) => props.handleMenuClick(e, ch)}
                                  >
                                    <div className="new-submenus-label">
                                      {lang === "ma" ? ch.label_ma ? ReactHtmlParser(ch.label_ma) : "" : ch.label_en}
                                    </div>
                                  </div>
                                )}
                              </React.Fragment>
                            ))}
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {/* Check if this menu item should be shown based on special permissions */}
                    {(!item.specialPermissions ||
                      (item.specialPermissions.includes(activeUserType))) && (
                        <div className="new-menu-item" key={item.id}>
                          <div className="new-menu-title">
                            {lang === "ma" ? item.label_ma : item.label_en}
                          </div>
                          <div className="new-menu-subItem">
                            {item.children.map((ch) => (
                              <React.Fragment key={ch.id}>
                                {ch.show && (
                                  <>
                                    {/* Check special permissions for child items */}
                                     {(!ch.specialPermissions ||
                                       (ch.specialPermissions.includes(activeUserType))) &&
                                       (!ch.minStatus ||
                                         (ch.applyStatus
                                           ? ch.applyStatus == activeUserType
                                             ? ch.minStatus == activeUserStatus
                                             : true
                                           : ch.minStatus == activeUserStatus)) ? (
                                      <div
                                        className="new-menu-item-data"
                                        onClick={(e) => props.handleMenuClick(e, ch)}
                                      >
                                        <div className="new-submenus-label">
                                          {lang === "ma" ? ch.label_ma : ch.label_en}
                                        </div>
                                      </div>
                                    ) : activeUserType === 21 ? (
                                      !ch.hideForAdmin && (
                                        <div
                                          className="new-menu-item-data"
                                          onClick={(e) =>
                                            props.handleMenuClick(e, ch)
                                          }
                                        >
                                          <div className="new-submenus-label">
                                            {lang === "ma"
                                              ? ch.label_ma
                                              : ch.label_en}
                                          </div>
                                        </div>
                                      )
                                    ) : (
                                      <div
                                        className="new-menu-item-data"
                                        onClick={(e) => props.handleMenuClick(e, ch)}
                                      >
                                        <div className="new-submenus-label">
                                          {lang === "ma" ? ch.label_ma : ch.label_en}
                                        </div>
                                      </div>
                                    )}
                                  </>
                                )}
                              </React.Fragment>
                            ))}
                          </div>
                        </div>
                      )}
                  </>
                )}
              </React.Fragment>
            );
          })}
        </div>
        <div className="new-menu-home">
          <div
            className="new-home-icon-cont"
            onClick={(e) => props.handleMenuClick(e, homeData)}
          >
            <CustomIcons iconName="home" iconClass="new-menu-home-icon" />
          </div>
        </div>
      </div>
    </div>
  );
}
